var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"company-activity",class:{english:_vm.lang=='EN'},style:(_vm.isMobile?{paddingTop:'0'}:'')},[_c('div',{staticClass:"wow fadeInUp hidden-xs",staticStyle:{"display":"flex","align-items":"center","flex-direction":"column","margin-bottom":"1.75rem"}},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t('joinUs.Activities')))])]),_vm._v(" "),_c('Lantern',{attrs:{"detailContent":_vm.groupBuild}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/common/joinus/CompanyActivity.vue?vue&type=template&id=5fb6b567&scoped=true&
// module id = null
// module chunks = 